import React from "react"
import Proptypes from "prop-types"
import { Row, Col } from "reactstrap"

import Constants from "../../../../constants/solutions.json"

import Image from "../../../../images/solutions/onlineTutoring/Online education.png"

const SideBySide = props => {
  return (
    <div className="side-by-side">
      <Row>
        <Col sm="6" xs="12">
          <img
            src={Image}
            alt="Jitsi Meet for virtual classrooms, online tutoring and learning"
          />
        </Col>
        <Col sm="6" xs="12" className="text">
          <div className="title large-font">
            {Constants.SOLUTIONS.onlineTutoring.blueRow.i2.title}
          </div>
          <div className="description medium-font">
            {Constants.SOLUTIONS.onlineTutoring.blueRow.i2.description}
          </div>
        </Col>
      </Row>
    </div>
  )
}

// SideBySide.prototype={
//   title: Proptypes.any,
//   description: Proptypes.any,
//   blueTitle: Proptypes.any,
// };

export default SideBySide
